/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  combineReducers,
  configureStore,
  isRejectedWithValue,
  type Middleware,
} from '@reduxjs/toolkit'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'

import { toast } from 'react-toastify'

import Cookies from 'js-cookie'
import storage from 'redux-persist/lib/storage'
import { COOKIE_KEY } from '../../constants'
import { apiSlice, imagesApiSlice } from '../api/apiSlice'
import authReducer, { signOut } from '../auth/auth.reducer'

/**
 * @description Middleware for logging or toast notifications
 * @returns next func
 */
export const rtkQueryResponseFeedbackMiddleware: Middleware =
  () => (next) => (action) => {
    const dispatch = store.dispatch
    // returns action type: query || mutation

    const actionType = (): string => (action as any)?.meta?.arg?.type

    if (actionType() === 'mutation') {
      if (isRejectedWithValue(action)) {
        if ((action as any)?.payload?.data?.error?.includes('authorization')) {
          Cookies.remove(COOKIE_KEY)
          dispatch(signOut())
          toast.error('Session expired, please login', { theme: 'colored' })
        }
      }
    }

    if (actionType() === 'query') {
      if (isRejectedWithValue(action)) {
        if ((action as any)?.payload?.data?.error?.includes('authorization')) {
          Cookies.remove(COOKIE_KEY)
          dispatch(signOut())
          window.location.href = '/auth/login'
        }
      }
    }

    return next(action)
  }

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  [imagesApiSlice.reducerPath]: imagesApiSlice.reducer,
  auth: authReducer,
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware): any =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      apiSlice.middleware,
      imagesApiSlice.middleware,
      rtkQueryResponseFeedbackMiddleware,
    ]),
  devTools: true,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
